import React,  {Component} from 'react';
import { Col, FlexboxGrid, Button, Input, InputGroup, Icon } from 'rsuite';
import {withTranslation} from 'react-i18next';
import { Image } from 'react-bootstrap';
import {isEmail} from 'validator';
import PasswordStrengthBar from 'react-password-strength-bar';
import Swal from 'sweetalert2';
import {hasCapital, hasSpecial} from '../lib/functions';

class Recover extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.sendRecover = this.sendRecover.bind(this);
        this.verify = this.verify.bind(this);

        this.state = {
            email:"",
            show_error:false,
            sending:false,
            password:"",
            confirm_password:"",
            code:"",
            error_password:""
        }
    }

    handleChange(name, value){
        if(name === 'password' || name === 'confirm_password'){
			var error = '';
			var caracteres = '', letra = '', simbolo = '';

			this.setState({[name]: value});

			if(name === 'password'){
				if(this.state.confirm_password !== "" && this.state.confirm_password !== value){
					error = this.props.t('error_alert.password_no_match');
				}
			}

			if(name === 'confirm_password'){
				if(this.state.password !== "" && this.state.password !== value){
					error = this.props.t('error_alert.password_no_match');
				}
			}

			if(error === ''){
				error = this.props.t('error_alert.password_contain');
				if(value.length < 8){
					caracteres = this.props.t('error_alert.min_character');
				}

				if(!hasCapital(value)){
					letra = this.props.t('error_alert.one_capital');
				}

				if(!hasSpecial(value)){
					simbolo = this.props.t('error_alert.one_symbol');
				};

				if(caracteres === "" && letra === "" && simbolo === ""){
					error = "";
				}else{
					error = error+caracteres+letra+simbolo;
				}
			}

			this.setState({error_password: error});
		}else{
            this.setState({[name]: value});
        }

    }

    async sendRecover(){
        if(isEmail(this.state.email)){
            this.setState({show_error:false});

            var req = await this.props.fetchRequest({
                api:'auth',
                method:'POST',
                url:'auth/forgot-password',
                obj:{
                    email: this.state.email
                },
                modal:this.props.modal_loader,
                message_modal:this.props.t('modal.spin.sending')
            });

            if(req !== undefined){
                this.setState({sending:true});

            }

        }else{
            this.setState({show_error:true});
        }
    }

    async verify(){
        var error = "";
        if(this.state.password !== "" && this.state.confirm_password !== "" && this.state.code !== ""){
            if(this.state.password !== this.state.confirm_password){
                error = this.props.t('error_alert.password_no_match');
            }
        }else{
            error = this.props.t('error_alert.incomplete_fields')
        }

        if(error === ""){
            var obj = {
                email: this.state.email,
                newPassword: this.state.password,
                verificationCode: this.state.code
            };

            var req = await this.props.fetchRequest({
                api:'auth',
                method:'POST',
                url:'auth/reset-password',
                obj:obj,
                modal:this.props.modal_loader,
                message_modal:this.props.t('modal.spin.confirming')
            });

            if(req !== undefined){
                Swal.fire(this.props.t('success_alert.confirm'), this.props.t('success_alert.password_reset'), 'success');
                this.props.history.push('/login');
            }

        }else{
            Swal.fire('Error', error, 'error');
        }
    }

    render(){
        const {t} = this.props;
        return(
            <div className="login-page">
            <FlexboxGrid justify="center">
                <Col xs={24} sm={16} md={12} lg={10} >
                    <div className="login-illustration">
                        <Image src="images/login/login1.png"/>
                    </div>
                    <div className="login-form">
                        <div>
                            <h2>{t('screen.recover_password.title')}</h2>
                        </div>
                        {this.state.sending ?
                            <div style={{padding:'0 15px 15px'}}>
                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <p style={{textAlign:'justify'}}>
                                            {t('screen.recover_password.confirm')}
                                        </p>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <InputGroup inside style={{overflow: 'unset'}}>
                                            <Input
                                                size="sm"
                                                name="email"
                                                id="email"
                                                value={this.state.email}
                                                disabled
                                            />
                                            <InputGroup.Addon>
                                                <Icon icon="envelope-o" />
                                            </InputGroup.Addon>
                                        </InputGroup>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16} style={{textAlign:'left'}}>
                                        <PasswordStrengthBar
                                            password={this.state.password}
                                            minLenght={8}
                                            scoreWords={[
                                                t('general.password_score_word.very_weak'),
                                                t('general.password_score_word.weak'),
                                                t('general.password_score_word.good'),
                                                t('general.password_score_word.very_good'),
                                                t('general.password_score_word.strong')
                                            ]}
                                            shortScoreWord={t('general.password_score_word.small')}
                                        />
                                        {this.state.error_password !== "" &&
                                            <span style={{fontSize:10, color:'red'}}>{this.state.error_password}</span>
                                        }
                                    </Col>
                                </FlexboxGrid>
                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <InputGroup inside style={{overflow: 'unset'}}>
                                            <Input
                                                type="password"
                                                placeholder={t('screen.recover_password.password')}
                                                size="sm"
                                                name="password"
                                                id="password"
                                                value={this.state.password}
                                                onChange={(value)=>this.handleChange('password', value)}
                                            />
                                            <InputGroup.Addon>
                                                <Icon icon="lock" />
                                            </InputGroup.Addon>
                                        </InputGroup>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <InputGroup inside style={{overflow: 'unset'}}>
                                            <Input
                                                type="password"
                                                placeholder={t('screen.recover_password.confirm_password')}
                                                size="sm"
                                                name="confirm_password"
                                                id="confirm_password"
                                                value={this.state.confirm_password}
                                                onChange={(value)=>this.handleChange('confirm_password', value)}
                                            />
                                            <InputGroup.Addon>
                                                <Icon icon="lock" />
                                            </InputGroup.Addon>
                                        </InputGroup>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <InputGroup inside style={{overflow: 'unset'}}>
                                            <Input
                                                placeholder={t('screen.recover_password.code')}
                                                size="sm"
                                                name="code"
                                                id="code"
                                                value={this.state.code}
                                                autoComplete="off"
                                                onChange={(value)=>this.handleChange('code', value)}
                                            />
                                            <InputGroup.Addon>
                                                <Icon icon="shield" />
                                            </InputGroup.Addon>
                                        </InputGroup>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center">
                                    <Col xs={22} sm={20} md={16} lg={16} style={{textAlign:'right'}}>
                                        <Button
                                            size="sm"
                                            style={{marginRight:8}}
                                            onClick={(e)=>{
                                                e.preventDefault();
                                                return this.setState({sending:false, password:"", confirm_password:"", code:""});
                                            }}
                                        >{t('button.return')}</Button>
                                        <Button color="blue" size="sm" onClick={()=>this.verify()}>{t('button.confirm')}</Button>
                                    </Col>
                                </FlexboxGrid>
                            </div>
                        :
                            <div style={{padding:'0 15px 15px'}}>
                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <p style={{textAlign:'justify'}}>
                                            {t('screen.recover_password.recover')}
                                        </p>
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center" className="form-group">
                                    <Col xs={22} sm={20} md={16} lg={16}>
                                        <InputGroup inside style={{overflow: 'unset'}}>
                                            <Input
                                                placeholder={t('screen.recover_password.email')}
                                                size="sm"
                                                name="email"
                                                id="email"
                                                value={this.state.email}
                                                onChange={(value)=>{
                                                    if(isEmail(value)){
                                                        this.setState({show_error:false});
                                                    }else{
                                                        this.setState({show_error:true});
                                                    }
                                                    this.setState({email:value});
                                                }}
                                            />
                                            <InputGroup.Addon>
                                                <Icon icon="envelope-o" />
                                            </InputGroup.Addon>
                                        </InputGroup>
                                        {this.state.show_error &&
                                            <span style={{fontSize:10, color:'red'}}>{t('error_alert.invalid_email')}</span>
                                        }
                                    </Col>
                                </FlexboxGrid>

                                <FlexboxGrid justify="center">
                                    <Col xs={22} sm={20} md={16} lg={16} style={{textAlign:'right'}}>
                                        <Button
                                            size="sm"
                                            style={{marginRight:8}}
                                            onClick={(e)=>{e.preventDefault(); return this.props.history.push('/login')}}
                                        >{t('button.cancel')}</Button>
                                        <Button color="blue" size="sm" onClick={()=>this.sendRecover()}>{t('button.send')}</Button>
                                    </Col>
                                </FlexboxGrid>
                            </div>
                        }
                    </div>
                </Col>
            </FlexboxGrid>
            </div>
        )
    }
}

export default withTranslation('translations')(Recover);
